"use strict";

import { StyleSheet } from 'react-native';
export const sharedStyles = StyleSheet.create({
  flexDirectionRow: {
    flexDirection: 'row'
  },
  opacity0: {
    opacity: 0
  },
  opacity1: {
    opacity: 1
  },
  overflowHidden: {
    overflow: 'hidden'
  },
  root: {
    flex: 1
  }
});
//# sourceMappingURL=styles.js.map